import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom';

import PageHeader from 'src/components/shared/page-header';
import WorkerDetails from 'src/components/worker';

const WorkerDetailsPage: React.FC = () => {
const [searchParams,] = useSearchParams();
const params = useParams()
const workerName =searchParams.get('worker') ?? ''

  return (
    <div className="min-h-screen w-full flex flex-col">
      <PageHeader title={workerName} isDetail/>
        <div className="flex items-center flex-col gap-2">   
         <WorkerDetails workerId={params?.workerId!}/>
        </div>
    </div>
  )
}

export default WorkerDetailsPage